// extracted by mini-css-extract-plugin
module.exports = {"bookWrapper":"_1yUwP8s8_G-Tjs9mV-aq34 _3Y7xEtrTgaC28IokfnEvTA"};